import { useState } from "react";
import CustomerList from "./customer_intelligence/CustomerList";
import CustomerProfile from "./customer_intelligence/CustomerProfile";

// Customer list ⇄ one customer's profile. The list stays mounted (hidden) so
// its filters and page survive a round trip to a profile.
const CustomerIntelligenceTab = () => {
  const [userId, setUserId] = useState<string | null>(null);

  return (
    <div>
      <div style={{ display: userId ? "none" : undefined }}>
        <CustomerList onOpen={setUserId} />
      </div>
      {userId && (
        <CustomerProfile
          userId={userId}
          onBack={() => {
            setUserId(null);
            window.scrollTo(0, 0);
          }}
        />
      )}
    </div>
  );
};

export default CustomerIntelligenceTab;
